document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".tab-title");
  const tabContainers = document.querySelectorAll(".tab");
  const collections = document.querySelectorAll(".package-collection");
  const collections2 = document.querySelectorAll(".portfolio_package");
  const planTables = document.querySelectorAll(".plan-table");

  // Function to adjust package collection widths
  function adjustPackageCollectionWidth() {
    // Find the currently visible plan table
    const visiblePlanTable = document.querySelector('.plan-table[style*="display: block"]');
    
    if (!visiblePlanTable) return;
    
    // Get the table-left-topic from the visible table
    const tableLeftTopic = visiblePlanTable.querySelector('.table-left-topic');
    
    if (!tableLeftTopic) return;
    
    const tableLeftTopicWidth = tableLeftTopic.offsetWidth;
    const newWidth = `calc(100% - ${tableLeftTopicWidth}px)`;
    
    // Apply the width to ALL package-collection elements (even hidden ones)
    const packageCollections = document.querySelectorAll('.package-collection');
    packageCollections.forEach(packageCollection => {
      packageCollection.style.width = newWidth;
    });
  }

  function activateTab(tab, instant) {
    const selectedTab = tab.dataset.tab;

    tabs.forEach(t => t.classList.remove("active"));
    tab.classList.add("active");

    // Find currently visible collections to fade out
    const visibleCollections = [...collections, ...collections2].filter(
      c => c.style.display !== "none" && c.dataset.tabPackage !== selectedTab
    );

    if (instant || visibleCollections.length === 0) {
      // No animation on first load
      switchContent(selectedTab);
      return;
    }

    // Fade out visible collections
    visibleCollections.forEach(c => {
      c.classList.remove("fade-in");
      c.classList.add("fade-out");
    });

    // After fade-out completes, swap content and fade in
    setTimeout(() => {
      switchContent(selectedTab);

      // Get newly visible collections and fade them in
      const newVisible = [...collections, ...collections2].filter(
        c => c.style.display !== "none"
      );
      newVisible.forEach(c => {
        c.classList.add("fade-out");
        c.offsetHeight; // force reflow
        c.classList.remove("fade-out");
        c.classList.add("fade-in");
      });
    }, 350);
  }

  function switchContent(selectedTab) {
    collections.forEach(collection => {
      collection.style.display = (collection.dataset.tabPackage === selectedTab) ? "" : "none";
    });

    collections2.forEach(collection => {
      collection.style.display = (collection.dataset.tabPackage === selectedTab) ? "" : "none";
    });

    planTables.forEach(planTable => {
      planTable.style.display = (planTable.dataset.tab === selectedTab) ? "block" : "none";
    });

    // Adjust widths after tab switch
    setTimeout(() => {
      adjustPackageCollectionWidth();
    }, 100);
  }

  tabContainers.forEach(container => {
    container.addEventListener("click", function () {
      const tabTitle = this.querySelector(".tab-title");
      if (tabTitle) {
        activateTab(tabTitle);
      }
    });
  });

  if (tabs.length) {
    activateTab(tabs[0], true);
  }

  // Initial width adjustment
  setTimeout(() => {
    adjustPackageCollectionWidth();
  }, 100);

  // Adjust on window resize
  window.addEventListener('resize', adjustPackageCollectionWidth);

  // Optional: Use ResizeObserver for dynamic changes
  const allTableLeftTopics = document.querySelectorAll('.table-left-topic');
  if (window.ResizeObserver && allTableLeftTopics.length > 0) {
    const resizeObserver = new ResizeObserver(() => {
      adjustPackageCollectionWidth();
    });
    allTableLeftTopics.forEach(topic => {
      resizeObserver.observe(topic);
    });
  }
});